import { render, staticRenderFns } from "./workRecordsWorkerSummaryTable.vue?vue&type=template&id=b0ec65de&"
import script from "./workRecordsWorkerSummaryTable.vue?vue&type=script&lang=ts&"
export * from "./workRecordsWorkerSummaryTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports